import React from 'react';
import Card from '../card/card';
import Slider from 'react-slick';
import classes from './stepper.module.scss';

const Stepper = ({ steps, type }: any) => {
  const settings = {
    dots: false,
    infinite: steps.length > 2,
    speed: 500,
    centerPadding: '40px',
    slidesToShow: 2,
    swipe: false,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
          swipe: true
        }
      }
    ]
  };
  return (
    <div className={'stepper'}>
      <Slider {...settings}>
        {steps.map((step: any) => (
          <div key={step.id} className={classes.step}>
            <Card type={type} card={step} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Stepper;
